module.exports = __webpack_public_path__ + "static/img/searchbg.178dfc3d.png";